import React, { Fragment } from 'react'
import { Typography, Grid, List, ListItem, Divider, ListItemText, ListItemAvatar, ListSubheader } from '@material-ui/core';
import DayCard from './DayCard';
import TimeAtar from './TimeAtar';

const today = new Date().toISOString().substr(0, 10);

const Display = (props) => {

  // for grouping i need to group them... like map by date...

  const todaysSchedule = props.days.filter(day => day.date === today);

  const todaysCards =
    <Grid container spacing={1}>
      {todaysSchedule && todaysSchedule.map((day) => {
        return (
          <DayCard key={day.id} day={day} {...props} />
        )
      })}
    </Grid>

  return (
    <div>
      <Typography>All cards are being displayed</Typography>
      <List>
        {props.days && props.days.map((day, ix, arr) => {
          let notLast = ix !== arr.length - 1;
          return (
            <React.Fragment key={day.id}>
              <ListItem alignItems='flex-start'>
                <ListItemAvatar>
                  <TimeAtar hours={day.startTime.substr(0, 2)} minutes={day.startTime.substr(3, 2)} />
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <React.Fragment>
                      {day.classRoom.substr(0, 1)}<sub>{day.classRoom.substr(2, 1)}</sub>
                    </React.Fragment>
                  }
                  secondary={day.entry}
                />
              </ListItem>
              {notLast && <Divider />}
            </React.Fragment>

          )
        })}
      </List>
      <List>
        <ListSubheader>
          Day one
        </ListSubheader>
        <ListItem>
          <ListItemText
            primary='IV3'
            secondary='This is a true story!'
          />
          <ListItemText
            primary='Me myself and I'
            secondary='Do not listen to him! He is lying all the time. '
          />
        </ListItem>
        <Divider />
        <ListItem>
          <ListItemText
            primary={
              <React.Fragment>
                III<sub>3</sub>
              </React.Fragment>
            }
            secondary='Ustav i prava gradjana'
          />
        </ListItem>
        <Divider />
        <ListSubheader>Day Two</ListSubheader>
        <ListItem alignItems='flex-start'>
          <ListItemAvatar>
            <TimeAtar hours='12' minutes='24' />
          </ListItemAvatar>
          <ListItemText
            primary={
              <React.Fragment>
                III<sub>3</sub>
              </React.Fragment>
            }
            secondary='Ustav i prava gradjana'
          />
        </ListItem>
        <Divider />
      </List>
    </div>
  )
}

export default Display
